export interface AccountInfo {
  id: string;
  email: string | null;
  name: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  lastLoginAt: string | null;
  permissions?: string[];
  vendorAccounts?: VendorAccount[];
}
export interface VendorAccount {
  id: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  lastLoginAt: string;
  vendor: string;
  vendorUserId: string;
  vendorUserInfo: { [key: string]: any };
}

export interface UserInfo extends AccountInfo {
  app: string | null;
  token: string | undefined;
}

export enum Role {
  DOCTOR = 'DOCTOR',
  PHARMACIST = 'PHARMACIST',
  PATIENT = 'PATIENT',
}

export const permissionArrayObject = {
  deviceDisplay: 'DEVICE_DISPLAY',
  deviceControl: 'DEVICE_CONTROL',
  groupEdit: 'GROUP_EDIT',
  groupDelete: 'GROUP_DELETE',
  homeQR: 'HOME_QR',
  homeInit: 'HOME_INIT',
  homeEdit: 'HOME_EDIT',
  homeMove: 'HOME_MOVE',
  homeDelete: 'HOME_DELETE',
  notificationAll: 'NOTIFICATION_ALL',
  doctor: 'DOCTOR',
  drug: 'DRUG',
  hydro: 'figma-admin',
  mamoleo: 'mamoleo-admin',
};
